// extracted by mini-css-extract-plugin
export default {"timesRow":"Shifts_timesRow__MwyD+","inputContainerStyle":"Shifts_inputContainerStyle__yOU+h","time":"Shifts_time__26wuO","fixMenuButton":"Shifts_fixMenuButton__QoEDo"};